import { render, staticRenderFns } from "./IBANInput.vue?vue&type=template&id=2a22a72d&scoped=true"
import script from "./IBANInput.vue?vue&type=script&lang=js"
export * from "./IBANInput.vue?vue&type=script&lang=js"
import style0 from "./IBANInput.vue?vue&type=style&index=0&id=2a22a72d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a22a72d",
  null
  
)

export default component.exports